/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{cn as e}from"../../lib/utils.js";import r from"react";const a=r.forwardRef((({className:a,...s},t)=>r.createElement("textarea",{className:e("flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base/6 shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 sm:text-sm sm:leading-[22px]",a),ref:t,...s})));a.displayName="Textarea";export{a as default};
//# sourceMappingURL=Textarea.js.map
